import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams, Page, Pageable } from '@mctic/ng-core';
import { ObrigacaoRepassada } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class ObrigacaoRepassadaService {

  private readonly endpoint = '/sepin-backend/rest/obrigacoes-repassadas';

  constructor(private readonly http: McticHttpClient) {
  }

  salvarConsolidacao(obrigacao: ObrigacaoRepassada) {
    if (obrigacao.id) {
      return this.http.put(this.endpoint, obrigacao);
    }

    return this.http.post(this.endpoint, obrigacao);
  }

  consultar(pageable: Pageable) {
    const parametros = new McticHttpParams();
    parametros.setPageable(pageable);
    return this.http.get<Page<any>>(`${this.endpoint}/query`, {params: parametros.toHttpParams()});
  }

  excluir(id: number) {
    return this.http.delete(`${this.endpoint}/${id}`);
  }
}
